module.exports = __webpack_public_path__ + "img/salesman_registration_banner.6ba1f10c.png";